import { render, staticRenderFns } from "./highestProductiveUnproductive.vue?vue&type=template&id=0e868a74"
import script from "./highestProductiveUnproductive.vue?vue&type=script&lang=js"
export * from "./highestProductiveUnproductive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports